import { render, staticRenderFns } from "./productDescDia.vue?vue&type=template&id=1bde0a98&scoped=true"
import script from "./productDescDia.vue?vue&type=script&lang=js"
export * from "./productDescDia.vue?vue&type=script&lang=js"
import style0 from "./productDescDia.vue?vue&type=style&index=0&id=1bde0a98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bde0a98",
  null
  
)

export default component.exports